import "./style.css";
import { orderTypeEnum } from "../../../consts";
import React from "react";

export const NewOrder = ({
  progress = 0,
  iconSize,
  num,
  classname,
  id,
  isActive,
  draggable,
  side = "BUY",
  number,
  size,
  marketable,
  rate,
  ls = false,
  type,
  x,
  markers = [],
  setShowLines = () => {},
  showLines,
  simulation
}) => {
  const onShowLines = e => {
    if (!simulation) return;
    if (e.target.id === showLines) return;
    if (!e.target.id) return;
    setShowLines(e.target.id);
  };

  const hideLines = e => {
    if (!simulation) return;
    if (e.target.id !== showLines) return;
    setShowLines("");
  };

  const absPos = x
    ? {
        position: "absolute",
        zIndex: 100,
        left: x,
        top: "33%"
      }
    : {};

  const bgColors = {
    sell: "#FF3038",
    buy: "#00DE82"
  };

  let radius = 0;
  if (type === orderTypeEnum.xy || type === orderTypeEnum.lsh) {
    radius = 999;
  } else {
    radius = 0;
  }

  const style = {
    ...absPos,
    border: `4px solid ${bgColors[side.toLowerCase()]}`,
    opacity: isActive || !x ? 1 : 0.7,
    borderRadius: radius
  };

  const lshStyle = {
    border: `4px solid ${bgColors[side.toLowerCase()]}`,
    opacity: isActive || !x ? 1 : 0.7
  };

  return (
    <div
      className={`order ${classname}`}
      id={id}
      key={`${id}-${side}-${num}`}
      data-side={side}
      data-orderType={type}
      style={style}
      onMouseEnter={onShowLines}
      onMouseLeave={hideLines}
    >
      {type === orderTypeEnum.lsh && (
        <div id={id} className="order-lsh" style={lshStyle}></div>
      )}
      {num}
      {markers?.map((m, i) => {
        return (
          <div
            id={id}
            className={`order-stream-marker marker${id}${m.num}`}
            key={m.num + i}
            style={{
              left: m.left || "unset",
              right: m.right || "unset",
              top: m.top || "unset",
              bottom: m.bottom || "unset",
              background: m.color
            }}
          >
            {m.num}
          </div>
        );
      })}
    </div>
  );
};
